import { Checkbox } from "@/components/ui/checkbox";
import { SELECT_COLUMN_ID } from "constants/Constants";

const SELECT_COLUMN_WIDTH = 40;

// The width is pinned through minSize and maxSize: the tables' default minSize
// of 60 would otherwise widen it, and a width saved from an earlier resize
// would otherwise override `size`.
export const selectColumn = {
  id: SELECT_COLUMN_ID,
  size: SELECT_COLUMN_WIDTH,
  minSize: SELECT_COLUMN_WIDTH,
  maxSize: SELECT_COLUMN_WIDTH,
  enableResizing: false,
  enableSorting: false,
  meta: { isDisplay: true },
  header: ({ table }) => (
    <Checkbox
      checked={table.getIsAllRowsSelected()}
      indeterminate={table.getIsSomeRowsSelected()}
      onCheckedChange={checked => table.toggleAllRowsSelected(!!checked)}
      aria-label="Select all rows"
    />
  ),
  cell: ({ row }) => (
    <Checkbox
      checked={row.getIsSelected()}
      disabled={!row.getCanSelect()}
      indeterminate={row.getIsSomeSelected() && !row.getIsSelected()}
      onCheckedChange={checked => row.toggleSelected(!!checked)}
      aria-label="Select row"
    />
  ),
};
